import * as React from "react";
import {
  ArrayInput,
  AutocompleteInput,
  Create,
  CreateProps,
  ReferenceInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";

const LayoutCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="phone" label="layout.phone" />
          <TextInput fullWidth source="email" label="layout.email" />
          <TextInput fullWidth source="slogan" label="layout.slogan" />
          <TextInput fullWidth source="copyright" label="layout.copyright" />

          <ArrayInput source="options" label="layout.options">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="option" label="layout.option" />
              <ReferenceInput fullWidth source="link" reference="services">
                <AutocompleteInput
                  fullWidth
                  label="layout.link"
                  optionText={`serviceName.${locale}`}
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};

export default LayoutCreate;
